import React from "react";
import ScholarshipBox from "../../common/scholarship_box";
import styles from "./tem_two_scholarships.module.scss";
import { createMarkup } from "@unisearch/helpers/utils";

export const TemTwoScholarships = ({
  universityData,
  university_name,
  pageData,
}) => {
  const { scholarship } = universityData;
  return (
    <section className={styles.section_cholarships}>
      <div className="container">
        <div className={styles.wrapper}>
          <h2>International Students scholarships</h2>
          <div
            className="from_texteditor_wrapper"
            dangerouslySetInnerHTML={createMarkup(
              pageData?.scholarshipHighlight
            )}
          ></div>
          <h4>Popular scholarships</h4>
          <div className={styles.scholarship_box_wrapper}>
            {scholarship.length < 0 &&
              scholarship
                ?.slice(0, 4)
                .map((data, i) => (
                  <ScholarshipBox
                    key={i}
                    title={data.name}
                    courseLevel={data.courseLevel?.levelName}
                    specialization={data.specialization?.name}
                    value={data.value}
                    deadline={data.deadline}
                    eligibility={data.eligibility}
                    externalLink={data.externalLink}
                  />
                ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TemTwoScholarships;
